<a (click)="openUserRoleExplainer()">
  {{ 'user-role-explainer.toggle-link-text' | translate }}
</a>
